import { LoadablePaint } from '@confluence/loadable';

export const InvalidExtensionLoader = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-InvalidExtension" */ './InvalidExtension'))
			.InvalidExtension,
});
